// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container__310er","last_column":"HomePage_last_column__xAgj5","enlarge_content":"HomePage_enlarge_content__9_OHj"};